import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { PaymentFormInfoSliceInitialState } from './paymentFormInfoTypes';
import {
  setPaymentFormAddress,
  setPaymentFormAddressErrors,
  setPaymentFormCardholderName,
  setPaymentFormCardholderNameError
} from './paymentFormInfoActions';
import { IAddress } from '../../customer/customerTypes';

const initialState: PaymentFormInfoSliceInitialState = {
  address: {
    country: '',
    line1: '',
    line2: '',
    postalCode: '',
    city: ''
  } as IAddress,
  addressErrors: {
    country: '',
    line1: '',
    postalCode: '',
    city: ''
  } as Omit<IAddress, 'line2'>,
  cardholderName: '',
  cardholderNameError: ''
};

export const paymentFormInfoSlice = createSlice({
  name: '@@paymentFormInfo',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setPaymentFormAddress, (state, action: PayloadAction<IAddress>) => {
      state.address = action.payload;
    });
    builder.addCase(setPaymentFormAddressErrors, (state, action: PayloadAction<Omit<IAddress, "line2">>) => {
      state.addressErrors = action.payload;
    });
    builder.addCase(setPaymentFormCardholderName, (state, action: PayloadAction<string>) => {
      state.cardholderName = action.payload;
    });
    builder.addCase(setPaymentFormCardholderNameError, (state, action: PayloadAction<string>) => {
      state.cardholderNameError = action.payload;
    });
  },
});

export const paymentFormInfoSelector = createSelector(
  [(state: RootState) => state.paymentFormInfo],
  (info) => info
);

export const paymentFormAddressSelector = createSelector(
  [(state: RootState) => state.paymentFormInfo.address],
  (address) => address
);

export const paymentFormAddressErrorsSelector = createSelector(
  [(state: RootState) => state.paymentFormInfo.addressErrors],
  (addressErrors) => addressErrors
);

export const paymentFormCardholderNameSelector = createSelector(
  [(state: RootState) => state.paymentFormInfo.cardholderName],
  (cardholderName) => cardholderName
);

export const paymentFormCardholderNameErrorSelector = createSelector(
  [(state: RootState) => state.paymentFormInfo.cardholderNameError],
  (cardholderNameError) => cardholderNameError
);